export const IS_HEADER_MENU_ITEM_CALCULATOR_VISIBLE = false;
export const IS_HEADER_PAUSE_BUTTON_VISIBLE = false;
export const IS_HEADER_MENU_ITEM_SHORTCUTS_VISIBLE = false;
export const IS_HEADER_MENU_ITEM_ASSISTIVE_TECHNOLOGY_VISIBLE = false;
